export default __webpack_public_path__ + "static/media/sad-face.d5d6e0a1.png";